import React, { useEffect, useState } from "react";

import "./stylesTotalLifecycleStages.css";
import createPrivateAdminPanelInstance from "../../../../api/PrivateAdminPanelInstance";
import CustomDatePicker from "../../../CommonComponents/CustomDatePicker/CustomDatePicker";
import { API_ROUTES } from "../../../../api/ApiRoutes";

import dayjs from "dayjs";
import { Bar } from "react-chartjs-2";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import RebetLoader from "../../../CommonComponents/RebetLoader/RebetLoader";
import { InfoOutlined } from "@ant-design/icons";
import { Popover } from "antd";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const colors = ["#6177E8", "#E74C3C", "#71BF8A", "#9B59B6", "#3498DB"];

const options = {
  responsive: true,
  maintainAspectRatio: false,
  interaction: {
    mode: "index",
    intersect: false,
  },
  scales: {
    x: {
      beginAtZero: true,
      stacked: true,
    },
    y: {
      stacked: true,
    },
  },
  plugins: {
    legend: {
      display: false,
    },
    title: {
      display: false,
    },
    datalabels: {
      display: false,
      anchor: "end",
      align: "start",
      formatter: (value) => value.toLocaleString(),
      color: "black",
      font: {
        family: "Poppins-regular",
        weight: "bold",
      },
    },
    tooltip: {
      enabled: true,
      mode: "index",
      intersect: false,
      backgroundColor: "#252729",
      titleFont: {
        family: "Poppins-regular",
        size: 16,
        weight: "bold",
      },
      bodyFont: {
        family: "Poppins-regular",
        size: 14,
      },
      padding: 15,
      displayColors: true,
      overflow: true,
      callbacks: {
        label: function (tooltipItem) {
          const label = tooltipItem.dataset.label || "";
          const value = tooltipItem.raw;
          return `${label}: ${Intl.NumberFormat("en-US").format(value)}`;
        },
      },
    },
  },
};

function TotalLifecycleStages() {
  const token = JSON.parse(localStorage.getItem("token"));
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.IdToken
  );

  const [isLoading, setIsLoading] = useState(false);

  const thisMonthRange = [dayjs().startOf("month"), dayjs().endOf("month")];
  const [dates, setDates] = useState([]);

  const [allDates, setAllDates] = useState([]);
  const [chartData, setChartData] = useState({
    labels: [],
    datasets: [
      {
        label: "",
        data: [],
        backgroundColor: "",
      },
    ],
  });

  const labels = [
    {
      label: "New",
      color: colors[0],
      text: "Created the account <30 days and Active",
    },
    {
      label: "Reactivated",
      color: colors[1],
      text: "Player returning to active from Lapsed or Dormant Status and is active for less than 30 days",
    },
    {
      label: "Active",
      color: colors[2],
      text: "Active customers not falling in the New and Reactivated category (Created the account more than 30 days ago, reactivated more than 30 days ago)",
    },
    {
      label: "Lapsed",
      color: colors[3],
      text: "Not had a bet in the last 30 - 179 days",
    },
    {
      label: "Dormant",
      color: colors[4],
      text: "Not had a bet in the last 180 or more days",
    },
  ];

  const getTotalLifecycleStagesData = async (
    queryString = thisMonthRange,
    isQueryString = true
  ) => {
    setIsLoading(true);

    let startDate = "";
    let endDate = "";

    if (isQueryString) {
      let formattedQueryString = queryString.split("&");
      startDate = dayjs(formattedQueryString[0]).format("YYYY-MM-DD");
      endDate = dayjs(formattedQueryString[1]).format("YYYY-MM-DD");
    } else {
      startDate = queryString[0]?.format("YYYY-MM-DD");
      endDate = queryString[1]?.format("YYYY-MM-DD");
    }

    const params = {
      start_date: startDate,
      end_date: endDate,
    };
    try {
       const response = await PrivateAdminPanelInstance?.post(
         API_ROUTES?.GET_USER_LIFECYCLE_TIME_SERIES,
         params
       );

      // const response = {
      //   message: "user lifecycle time series retrieved successfully",
      //   data: {
      //     data: [
      //       {
      //         date: "2025-06-30",
      //         new: 1682,
      //         reactivated: 0,
      //         active: 7584,
      //         lapsed: 159,
      //         dormant: 0,
      //         total_users: 9425,
      //       },
      //       {
      //         date: "2025-07-01",
      //         new: 1910,
      //         reactivated: 0,
      //         active: 8274,
      //         lapsed: 177,
      //         dormant: 1,
      //         total_users: 10362,
      //       },
      //     ],
      //     chart_type: "stacked_bar",
      //     title: "User Lifecycle Analysis Over Time",
      //   },
      //   success: true,
      // };

      const data = response?.data?.data?.data;

      const allDates = Array.from(
        new Set(data.map((item) => item.date))
      ).sort();

      const chartData = {
        labels: allDates,
        datasets: [
          {
            label: "New",
            data: data.map((item) => item.new),
            backgroundColor: colors[0],
          },
          {
            label: "Reactivated",
            data: data.map((item) => item.reactivated),
            backgroundColor: colors[1],
          },
          {
            label: "Active",
            data: data.map((item) => item.active),
            backgroundColor: colors[2],
          },
          {
            label: "Lapsed",
            data: data.map((item) => item.lapsed),
            backgroundColor: colors[3],
          },
          {
            label: "Dormant",
            data: data.map((item) => item.dormant),
            backgroundColor: colors[4],
          },
        ],
      };

      setChartData(chartData);
      setAllDates(allDates);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getTotalLifecycleStagesData(dates, false);
  }, []);

  return (
    <div className="total-lifecycle-stages-container">
      <div className="total-lifecycle-stages-header">
        <h2>Total - Lifecycle Stages</h2>
        <CustomDatePicker
          getData={getTotalLifecycleStagesData}
          dates={dates}
          setDates={setDates}
          showPresets={true}
        />
      </div>
      <div className="total-lifecycle-stages-content">
        {isLoading ? (
          <RebetLoader width={100} height={100} />
        ) : (
          <div className="total-lifecycle-stages-column">
            <div className="total-lifecycle-stages-chart-header">
              {labels.map((label, index) => (
                <div className="total-lifecycle-stages-chart-header-item" key={index}>
                  <div
                    className="total-lifecycle-stages-chart-header-item-color"
                    style={{ backgroundColor: label.color }}
                  ></div>
                  <div className="total-lifecycle-stages-chart-header-item-label">
                    {label.label}
                  </div>
                  <Popover
                    content={
                      <div style={{ width: 300, color: "#FFF" }}>
                        {label.text}
                      </div>
                    }
                    trigger="hover"
                    placement="topRight"
                    overlayClassName="total-lifecycle-stages-chart-header-item-info-popover"
                  >
                    <InfoOutlined className="total-lifecycle-stages-chart-header-item-info" />
                  </Popover>
                </div>
              ))}
            </div>
            <div className="total-lifecycle-stages-chart">
              <Bar data={chartData} options={options} />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default TotalLifecycleStages;
